export type LocaleRecoveryOptions = {
  isCurrent: (language: string) => boolean;
  setCurrent: (language: string) => void;
  load: (language: string) => Promise<void>;
  forceEnglish: () => void;
  report: (error: unknown) => void;
};

export async function loadLocaleWithRollback(
  target: string,
  previous: string,
  english: string,
  options: LocaleRecoveryOptions,
): Promise<void> {
  try {
    await options.load(target);
  } catch (error) {
    options.report(error);
    if (!options.isCurrent(target)) return;

    options.setCurrent(previous);
    try {
      await options.load(previous);
    } catch (rollbackError) {
      options.report(rollbackError);
      if (!options.isCurrent(previous)) return;

      options.setCurrent(english);
      options.forceEnglish();
    }
  }
}
